import { render, staticRenderFns } from "./urbano.vue?vue&type=template&id=449fe8f8&scoped=true&"
import script from "./urbano.vue?vue&type=script&lang=js&"
export * from "./urbano.vue?vue&type=script&lang=js&"
import style0 from "./urbano.vue?vue&type=style&index=0&id=449fe8f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449fe8f8",
  null
  
)

export default component.exports